export const PUBLIC_PATH = process.env.BASE_URL || '/my-favorite'